import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Fitter } from '@sc/data-access-models';
import { mergeArrays } from '@sc/utils';
import {
  FittersAddedAction,
  FittersClearedAction,
  FittersRemoveAction,
} from './fitters.actions';

@State<Fitter[]>({
  name: 'fitters',
  defaults: [],
})
@Injectable()
export class FittersState {
  @Action(FittersAddedAction)
  add(
    ctx: StateContext<Fitter[]>,
    { fitters, merge }: FittersAddedAction
  ): void {
    const state = ctx.getState();
    let newState = fitters.slice();
    if (merge) {
      newState = mergeArrays(
        newState ?? [],
        state ?? [],
        (fitter1, fitter2) => fitter1.id === fitter2.id
      );
    } else {
      newState.push(...(state || []));
    }
    ctx.setState(newState);
  }

  @Action(FittersClearedAction)
  clear(ctx: StateContext<Fitter[]>): void {
    ctx.setState(null);
  }

  @Action(FittersRemoveAction)
  remove(
    ctx: StateContext<Fitter[]>,
    { fittersToRemove }: FittersRemoveAction
  ): void {
    ctx.setState(
      ctx.getState()?.filter((f) => !fittersToRemove.includes(f.id)) || []
    );
  }
}
